import axios from 'axios';
import i18n from '@/i18n';

/**
 * Account language ("fr" / "en") used by the server for every transactional
 * e-mail the user receives. The site's own language is unchanged: it stays
 * the one chosen in the browser (LanguageSwitcher, localStorage ridalo_lang).
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const normalizeLang = (value) => {
  const code = String(value || '').toLowerCase().split(/[-_]/)[0];
  return code === 'fr' || code === 'en' ? code : null;
};

/** Language currently displayed on the site. */
export const siteLanguage = () => normalizeLang(i18n.resolvedLanguage || i18n.language);

/** Save the signed-in user's language. Never throws. */
export const saveAccountLanguage = async (language) => {
  const lang = normalizeLang(language);
  if (!lang) return null;
  try {
    const { data } = await axios.put(`${API}/users/me/language`, { language: lang }, { withCredentials: true });
    return data?.preferred_language || lang;
  } catch (e) {
    return null;
  }
};
